import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, setEditError, selectServerPlanById, ServerPlanInterface } from "src/store/mine_craft/serverPlansSlice";
import { fetchServerPlan, updateServerPlan } from "src/actions/mine_craft/serverPlansActions";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import Form from './_partials/_Form';

const Edit = () => {
  const dispatch   = useAppDispatch();
  const location   = useLocation();
  const id: any    = useAppSelector(state => state.mineCraft.serverPlans.editId);
  const error      = useAppSelector(state => state.mineCraft.serverPlans.editError);
  const serverPlan = useAppSelector(state => id ? selectServerPlanById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchServerPlan(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: ServerPlanInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: ServerPlanInterface) {
    const resultAction = await dispatch(updateServerPlan({ id, data }));

    if (updateServerPlan.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-server-plan'>
        <h6 className="v-content-label">Edit Server Plan</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={serverPlan} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
